<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container-valider" @click.stop>
                    <div class="modal-header-valider">
                        {{ $t('_quitter_sans_enregistrer_') }} ?
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-valider">
                        {{ $t('_attention_vous_allez_perdre_')}}
                    </div>

                    <div class="modal-footer-valider">
                        <v-btn style="float: right; background-color: #F49301; padding: 1vh; font-size: 1rem"
                            @click="$emit('save')">
                            {{ $t('_enregistrer_et_quitter_') }}
                        </v-btn>
                        <v-btn style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw ; font-size: 1rem"
                            @click="$emit('confirm')">
                            {{ $t('_quitter_sans_enregistrer_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {

}


</script>

<style scoped>


.modal-container-valider {
    width: 40vw;
    height: 20vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header-valider {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-valider {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 1vh;
    padding-bottom: 3.5rem;
}

.modal-footer-valider {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

</style>